<script>
import ApiClient from '../utils/ApiClient'
const targetPath = 'ajax/login.php'
/**
 * user情報に関するservice
 * TODO storeパターンに書き直す
 */
export default {
  data () {
    return {
      users: []
    }
  },
  login: function (params, callback, errorHandler) {
    ApiClient.create(targetPath, params, {}, (response) => {
      console.log('login success')
      callback(response.data)
    }, (error) => {
      console.log('login failed')
      console.log(error)
      errorHandler(error)
    })
  },
  logout: function (params, callback, errorHandler) {
    var targetPath = 'ajax/logout.php'
    ApiClient.create(targetPath, params, {}, (response) => {
      callback(response.data)
    }, (error) => {
      console.log(error)
      errorHandler(error)
    })
  },
  logined (transactionId, callback, errorHandler) {
    var targetPath = 'ajax/customer.php' + '?transactionid=' + transactionId
    var params = ''
    ApiClient.check(targetPath, params, (response) => {
      callback(response.data)
    }, (error) => {
      errorHandler(error)
    })
  },
  /**
   * 新郎神父情報を取得
   **/
  findCustomer: function (transactionId, callback, errorHandler) {
    const targetPath = 'ajax/customer.php' + '?transactionid=' + transactionId
    const param = ''
    ApiClient.find(targetPath, param, (response) => {
      callback(response.data)
    }, (error) => {
      errorHandler(error)
    })
  },
  getPlayListCommitStatus: function (transactionId, callback, errorHandler) {
    const targetPath = 'ajax/customer.php' + '?transactionid=' + transactionId
    const param = ''
    ApiClient.find(targetPath, param, (response) => {
      callback(response.data.playlist_commit)
    }, (error) => {
      console.log(error)
      errorHandler(error)
    })
  },
  /**
   * 新郎新婦の情報を更新するメソッド
   **/
  updateCustomerInfo (params, callback, errorHandler) {
    const targetPath = 'ajax/customer_update.php'
    ApiClient.create(targetPath, params, {}, (response) => {
      callback(response)
    }, (error) => {
      console.error(error)
      errorHandler(error)
    })
  },
  createConstmerPlayList: function (params, callback, errorHandler) {
    var targetPath = 'ajax/customer_complete.php'
    ApiClient.create(targetPath, params, {}, (response) => {
      callback(response.data)
    }, (error) => {
      console.log(error)
      errorHandler(error)
    })
  },
  /**
   * 新郎新婦のプレイリストを更新
   **/
  updateConstmerPlayList: function (params, callback, errorHandler) {
    var targetPath = 'ajax/playlist_customer_rank.php'
    ApiClient.create(targetPath, params, {}, (response) => {
      callback(response.data)
    }, (error) => {
      console.log(error)
      errorHandler(error)
    })
  },
  /**
   * パスワードを変更するメソッド
   **/
  updatePassword: function (params, callback, errorHandler) {
    var targetPath = 'ajax/customer_update_password.php'
    ApiClient.create(targetPath, params, {}, (response) => {
      callback(response.data)
    }, (error) => {
      console.log(error)
      errorHandler(error)
    })
  },
  /**
   * パスワードを忘れたユーザーに再発行するためのメソッド
   * @param loginId
   * @param email
   * @param callback
   * @param errorHandler
   */
  forgetPassword: function (loginId, email, callback, errorHandler) {
    const targetPath = 'ajax/forgot_password.php'
    const formData = new URLSearchParams()
    formData.append('login_id', loginId)
    formData.append('email', email)
    ApiClient.create(targetPath, formData, {}, (response) => {
      callback(response.data)
    }, (error) => {
      console.log(error)
      errorHandler(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/services/UserService.vue